import io from "socket.io-client";

class SocketWorker {
  constructor(companyId, userId) {
    if (!SocketWorker.instance) {
      this.companyId = companyId;
      this.userId = userId;
      this.socket = null;
      this.configureSocket();
      this.eventListeners = {};
      SocketWorker.instance = this;
    }
    return SocketWorker.instance;
  }

  configureSocket() {
    const token = localStorage.getItem("token");

    this.socket = io(`${process.env.REACT_APP_BACKEND_URL}/workspace-${this.companyId}`, {
      autoConnect: true,
      reconnection: true,
      reconnectionDelay: 1000,
      reconnectionAttempts: Infinity,
      query: {
        userId: this.userId,
        token: token
      },
      transports: ["websocket", "polling"]
    });

    this.socket.on("connect", () => {
      console.log("Conectado ao servidor Socket.IO");
    });

    this.socket.on("connect_error", (error) => {
      console.error("Erro de conexão Socket.IO:", error.message);
    });

    this.socket.on("disconnect", () => {
      console.log("Desconectado do servidor Socket.IO");
      this.reconnectAfterDelay();
    });
  }

  on(event, callback) {
    this.connect();
    this.socket.on(event, callback);
    if (!this.eventListeners[event]) {
      this.eventListeners[event] = [];
    }
    this.eventListeners[event].push(callback);
  }

  emit(event, data) {
    this.connect();
    this.socket.emit(event, data);
  }

  off(event, callback) {
    this.connect();
    if (this.eventListeners[event]) {
      if (callback) {
        this.socket.off(event, callback);
        this.eventListeners[event] = this.eventListeners[event].filter(cb => cb !== callback);
      } else {
        this.eventListeners[event].forEach(cb => this.socket.off(event, cb));
        delete this.eventListeners[event];
      }
    }
  }

  disconnect() {
    if (this.socket) {
      this.socket.disconnect();
      this.socket = null;
      SocketWorker.instance = null;
      console.log("Socket desconectado manualmente");
    }
  }

  reconnectAfterDelay() {
    setTimeout(() => {
      if (!this.socket || !this.socket.connected) {
        console.log("Tentando reconectar após desconexão");
        this.connect();
      }
    }, 1000);
  }

  connect() {
    if (!this.socket) {
      this.configureSocket();
    }
  }

  forceReconnect() {}
}

const instance = (companyId, userId) => new SocketWorker(companyId, userId);

export default instance;
